<template>
    <span
            v-if="isVisible"
            class="omni-dropdown-icon"
            v-b-hover="handleHover"
    >
        <FontAwesomeIcon :icon="icon" class="icon" />
        <OmniDropdownCard
            v-if="isHovering"
            v-bind="$props"
        />
    </span>
</template>

<style>
.omni-dropdown-icon {
    display: inline-flex; /* Chosen to avoid icky hover behaviour. Uses inline-flex for responsive hover area. Unlike block, which spans full width, this only covers the element itself. */
    position: relative;
}
.omni-dropdown-icon .icon {
    cursor: pointer;
    width: .75rem;
    height: .75rem;
}
</style>

<script>
export default {
    name: "OmniDropdownIcon",
    props: {
        icon: {
            type: String,
            required: false,
            default: "external-link-alt",
        },
        cardItems: {
            type: Array,
            required: true,
            default: {},
        },
        cardItemVariables: {
            type: Object,
            required: false,
            default: {}, // avoids errors
        },
    },
    data() {
        return {
            isHovering: false,
        };
    },
    methods: {
        handleHover(isHovering) {
            this.isHovering = isHovering
        },
    },
    computed: {
        isVisible() {
            // Only show component when it actually has items. This way, we can
            // determine visibility in an easy and extendable way.
            return this.cardItems && Object.keys(this.cardItems).length !== 0;
        }
    }
}
</script>